import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'
import AlertEvaluationResults from './AlertEvaluationResults.js';
import AlertConfiguration from './AlertConfiguration.js';
import StockChart from '../stock/StockChart.js';
import AlertDataSample from './AlertDataSample.js'
import QuoteDateAnalysis from './QuoteDateAnalysis.js';
import AlertConfigChanges from "./AlertConfigChanges.js"
import AlertTrades from "./AlertTrades.js"
import AlertProfitChart from "./AlertProfitChart.js"
import AlertPerformanceHistory from "./AlertPerformanceHistory.js"
import RichTable from '../components/richTable/RichTable.jsx';
import AlertTradeResultsChart from './AlertTradeResultsChart.js';
import { useParams } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ActionResult from '../components/ActionResult.js'
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AlertTradeAnalysis from "./AlertTradeAnalysis.js";
import CreateAlgoModal from './CreateAlgoModal.js';
import DatePicker from "react-datepicker";
import ParameterSensitivityChart from './ParameterSensitivityChart.js';
import { Chart } from "react-google-charts";

import TwoStepConfirmationButton from '../components/TwoStepConfirmButton.js';
import CreateParameterTestModal from './CreateParameterTestModal.js';
import Dropdown from 'react-bootstrap/Dropdown';

function ConfigureAlert(props) {

    let { alertIdParam } = useParams();

    const [data, setData] = useState({})
    const [config, setConfig] = useState({})
    const [maxConfig, setMaxConfig] = useState({})
    const [defaultConfig, setDefaultConfig] = useState({})
    const [performance, setPerformance] = useState({})
    const [timePeriodChartData, setTimePeriodChartData] = useState(null);
    const [lastRunPerformance, setLastRunPerformance] = useState({})
    const [performanceArray, setPerformanceArray] = useState([])
    const [shouldSaveHistory, setShouldSaveHistory] = useState(false);
    const [result, setResult] = useState(null)
    const [updates, setUpdates] = useState(0);
    const [algoId, setAlgoId] = useState(null);
    const [algos, setAlgos] = useState([])
    const [startDate, setStartDate] = useState(new Date(2014, 0, 1));
    const [alertStartDate, setAlertStartDate] = useState(new Date(2007, 0, 1))
    const [endDate, setEndDate] = useState(new Date());
    const [addRandomness, setAddRandomness] = useState(false);
    const [monteCarloCount, setMonteCarloCount] = useState(10);
    const [alertId] = useState(alertIdParam ? alertIdParam : props.alertId)
    const [showDrawdown, setShowDrawdown] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [rangeParameter, setRangeParameter] = useState(null);
    const [sensitivityTests, setSensitivityTests] = useState([]);
    const [createParamTestModalOpen, setCreateParamTestModalOpen] = useState(false);
    const [historyAccordionExpanded, setHistoryAccordionExpanded] = useState(false);
    const historyAccordionRef = useRef(null);
    const configSectionRef = useRef(null);
    const [shouldScrollToHistory, setShouldScrollToHistory] = useState(false);
    const [symbols, setSymbols] = useState([])
    const [showSymbol, setShowSymbol] = useState(null);

    async function deleteSensitivityTest(parameterName) {
        const url = `/api/strategyAlertDeleteParameterSensitivityTest?alertId=${alertId}&parameterName=${parameterName}`;
        const r = await (await fetch(url, { method: 'POST' })).json();
        setResult(r);
        setUpdates(updates + 1);
    }

    async function runSensitivityTest(test) {
        setPerformanceArray([]);
        setRangeParameter(test.parameter_name);

        const decimalPlaces = String(test.increment).includes('.') ? String(test.increment).split('.')[1].length : 0;

        let counter = 0;
        // Use a small tolerance for the loop condition with floating point numbers
        for (let j = test.start_value; j <= test.end_value + 0.0001; j = j + test.increment) {
            let tempConfig = { ...config };
            tempConfig[test.parameter_name] = Number(j.toFixed(decimalPlaces));

            const scheduleEval = (configForEval, index) => {
                setTimeout(async () => {
                    await evaluateConfig(configForEval, index);
                }, 100 * index);
            };

            scheduleEval(tempConfig, counter);
            counter++;
        }
    }

    function handleCreateParamTestModalClose(apiResult) {
        setCreateParamTestModalOpen(false);
        if (apiResult) {
            setResult(apiResult);
            setUpdates(updates + 1);
            setMaxConfig({});
            setTimeout(() => {
                if (configSectionRef.current) {
                    configSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 150);
        }
    }

    useEffect(() => {
        (async function () {

            console.log("Loading alert", alertId);
            if (alertId) {
                let url = `/api/strategyAlert?alertId=` + alertId;
                let text = await (await fetch(url)).json();
                console.log("data", text);
                setData(text);
                if (text.defaultConfig) {
                    Object.keys(text.defaultConfig).forEach(key => {
                        if (text.config[key] === undefined || text.config[key] === null) {
                            text.config[key] = text.defaultConfig[key];
                        }
                    })
                }
                if (text.config) {
                    setConfig(text.config);
                }
                if (text.defaultConfig)
                    setDefaultConfig(text.defaultConfig);
                if (text.idalgos)
                    setAlgoId(text.idalgos);
                if (text.start_date) {
                    setAlertStartDate(new Date(text.start_date));
                }

                let end = new Date();
                let evalUrl = `/api/strategyAlertEvaluator?alertId=` + alertId;
                evalUrl += "&startDate=2014-1-1&endDate=" + end.getFullYear().toString() + "-" + (end.getMonth() + 1).toString() + "-" + (end.getDate()).toString();
                let performanceText = await (await fetch(evalUrl)).json();
                console.log("strategyAlertEvaluator", performanceText);
                setPerformance(performanceText);
                updateTimePeriodChartData(performanceText);
                setLastRunPerformance(performanceText);

                if (shouldSaveHistory) {
                    let perfArray = [];
                    perfArray.push({ id: 1, ...performanceText });
                    setPerformanceArray(perfArray);
                }

                const algosText = await (await fetch(`/api/algosByName?name=` + text.algo_name + "&symbol=" + text.symbol)).json();
                console.log("algos", algosText);
                setAlgos(algosText);

                const sensitivityTestsUrl = `/api/strategyAlertParameterSensitivityTests?alertId=` + alertId;
                const sensitivityTestsResult = await (await fetch(sensitivityTestsUrl)).json();
                console.log("sensitivityTestsResult", sensitivityTestsResult);
                if (sensitivityTestsResult && Array.isArray(sensitivityTestsResult)) {
                    setSensitivityTests(sensitivityTestsResult);
                }

                const symbolsText = await (await fetch(`/api/strategySymbols`)).json();
                console.log("symbolsText", symbolsText);
                setSymbols(symbolsText.sort((a, b) => a.localeCompare(b)));
            }
        })();
    }, [alertId, updates, shouldSaveHistory]);

    useEffect(() => {
        // This effect scrolls the history accordion into view when a new evaluation starts.
        // It's triggered when performanceArray is cleared.
        let timer;
        if (historyAccordionExpanded && historyAccordionRef.current) {
            if (shouldScrollToHistory) {
                // A small timeout gives the accordion time to animate open before scrolling.
                timer = setTimeout(() => {
                    historyAccordionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    if (historyAccordionRef.current) {
                        historyAccordionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                    setShouldScrollToHistory(false); // Reset after scrolling
                }, 150);
            }
            return () => clearTimeout(timer);
        }
    }, [shouldScrollToHistory, historyAccordionExpanded]);


    function shouldAllowEdits() {
        if (props.role === 3) return true;
        else return false;
    }
    function shouldAllowView() {
        if (props.role === 3) return true;
        else return false;
    }

    function deleteTestFormatter(cell, row) {
        return <TwoStepConfirmationButton id={row.parameter_name} text="Delete" onConfirmed={deleteSensitivityTest} />
    }

    function runTestFormatter(cell, row) {
        return <button className="btn btn-primary btn-sm" onClick={() => runSensitivityTest(row)}>Run</button>
    }

    async function handlePauseClicked() {
        console.log("handleSubmit");
        const url = "/api/strategyAlertStatus?alertId=" + alertId + "&paused=" + !data.paused
        console.log(url);
        const r = await (await fetch(url, {
            method: 'POST'
        })).json();
        setResult(r);
        setUpdates(updates + 1);
    }

    async function handleSubmit() {
        console.log("handleSubmit");
        const url = "/api/strategyAlertUpdate?alertId=" + alertId + "&startDate=" + alertStartDate.toLocaleDateString()
        console.log(url);
        const r = await (await fetch(url, {
            method: 'POST',
            body: JSON.stringify(config)
        })).json();
        console.log("Result from api call", r);
        setResult(r);
    }

    async function handleRememberConfig() {
        console.log("handleRememberConfig");
        const url = "/api/pendingAlertConfigChange?alertId=" + alertId
        const r = await (await fetch(url, {
            method: 'POST',
            body: JSON.stringify(config)
        })).json();
        setResult(r);
        handleCloseConfigMenu();
    }

    async function handleForgetConfig() {
        console.log("handleForgetConfig");
        const url = "/api/pendingAlertConfigChange?alertId=" + alertId
        const r = await (await fetch(url, {
            method: 'POST',
        })).json();
        setResult(r);
        handleCloseConfigMenu();
    }

    async function loadRememberedConfig() {
        const url = "/api/pendingAlertConfig?alertId=" + alertId
        const r = await (await fetch(url)).json();
        if (r && r.length) {
            setConfig(r[0].config);
            setResult({ success: "Remembered config" })
        }
        handleCloseConfigMenu();
        handleEvaluate(r[0].config);
    }

    async function delay(milliseconds) {
        return new Promise(resolve => {
            setTimeout(resolve, milliseconds);
        });
    }

    async function handleSyncBacktestTrades() {
        for (let i = 0; i < algos.length; i++) {
            const algo = algos[i];
            console.log(algo);
            if (algo.name === data.algo_name && algo.symbol === data.symbol) {
                const id = algo.idalgos;
                console.log("Syncing trades with algoId", id);
                const url = `/api/algoSyncWithStrategyAlerts?algoId=` + id;
                const text = await (await fetch(url, {
                    method: 'POST'
                })).json();
                setResult(text);
                await delay(2000);
            }
        }
    }

    async function handleReset() {
        setPerformanceArray([]);
        setMaxConfig({});
        setUpdates(updates + 1);
    }

    async function handleEvaluate(conf = null, start = null, end = null) {
        console.log("handleEvaluate");
        setShowSymbol(null);
        let url = "/api/strategyAlertEvaluator?alertId=" + alertId
        let startToUse = start ? start : startDate;
        let endToUse = end ? end : endDate;
        if (startDate) url += "&startDate=" + startToUse.getFullYear().toString() + "-" + (startToUse.getMonth() + 1).toString() + "-" + (startToUse.getDate()).toString();
        if (endDate) url += "&endDate=" + endToUse.getFullYear().toString() + "-" + (endToUse.getMonth() + 1).toString() + "-" + (endToUse.getDate()).toString();
        url += "&addRandomness=" + (addRandomness ? 'true' : 'false');
        console.log(url);
        const r = await (await fetch(url, {
            method: 'POST',
            body: conf ? JSON.stringify(conf) : JSON.stringify(config)
        })).json();
        console.log("strategyAlertEvaluator", r);
        setLastRunPerformance(r);
        updateTimePeriodChartData(r);

        if (shouldSaveHistory) {
            console.log("Saving history");
            let perfArray = [];
            perfArray.push({ id: performanceArray.length + 1, ...r });
            performanceArray.forEach(p => {
                perfArray.push(p);
            })
            setPerformanceArray(perfArray);
        }
    }

    async function handleMonteCarlo(conf = null, start = null, end = null) {
        console.log("handleMonteCarlo");
        setShowSymbol(null);
        let url = "/api/strategyAlertMonteCarlo?alertId=" + alertId + "&count=" + monteCarloCount
        let startToUse = start ? start : startDate;
        let endToUse = end ? end : endDate;
        if (startDate) url += "&startDate=" + startToUse.getFullYear().toString() + "-" + (startToUse.getMonth() + 1).toString() + "-" + (startToUse.getDate()).toString();
        if (endDate) url += "&endDate=" + endToUse.getFullYear().toString() + "-" + (endToUse.getMonth() + 1).toString() + "-" + (endToUse.getDate()).toString();
        url += "&addRandomness=" + (addRandomness ? 'true' : 'false');
        console.log(url);
        const r = await (await fetch(url, {
            method: 'POST',
            body: conf ? JSON.stringify(conf) : JSON.stringify(config)
        })).json();
        setPerformance(r);
        updateTimePeriodChartData(r);

        if (shouldSaveHistory) {
            let perfArray = [];
            perfArray.push({ id: performanceArray.length + 1, ...r });
            performanceArray.forEach(p => {
                perfArray.push(p);
            })
            setPerformanceArray(perfArray);
        }
    }

    async function evaluateConfig(c, arrayIndex) {
        setShowSymbol(null);
        let url = "/api/strategyAlertEvaluator?alertId=" + alertId
        if (startDate) url += "&startDate=" + startDate.toLocaleDateString();
        if (endDate) url += "&endDate=" + endDate.toLocaleDateString();
        url += "&addRandomness=" + (addRandomness ? 'true' : 'false');
        const r = await (await fetch(url, {
            method: 'POST',
            body: JSON.stringify(c)
        })).json();
        console.log("setPerformance", r);
        setLastRunPerformance(r);
        updateTimePeriodChartData(r);
        setPerformanceArray(prevArray => [...prevArray, { id: arrayIndex, ...r, config: c }]);
    }

    function handleClearResults() {
        setPerformanceArray([]);
    }

    function handleStrip() {
        let tempConfig = JSON.parse(JSON.stringify(config));
        tempConfig.stopLossPercent = 0;
        tempConfig.stopLossProtectProfitPercent = 0;
        tempConfig.targetProfitPercent = 0;
        tempConfig.stopLossAtr = 0;
        tempConfig.targetProfitAtr = 0;
        tempConfig.requiredSma = 0;
        tempConfig.maxSpikeInVolatility = 0;
        tempConfig.maxSpikeInVix = 0;
        tempConfig.exitSma = 0;
        tempConfig.meanReversionExitSma = 0;
        tempConfig.trailingStopAtrMultiplier = 0;
        tempConfig.fastExitOnVolatilitySpike = 0;
        tempConfig.minBarsBetweenTrades = 0;
        tempConfig.maxDurationBars = 0;
        tempConfig.shouldExitCloseBreaksPrevHighLow = false;
        tempConfig.requireBearMarket = false;
        handleConfigUpdate(tempConfig);
    }

    function isInt(n) {
        return Number(n) === n && n % 1 === 0;
    }

    function onDataSampleUpdated(startDate, endDate) {
        setStartDate(startDate);
        setEndDate(endDate);
        handleEvaluate(null, startDate, endDate);
    }

    function onAddRandomnessUpdated(shouldAddRandomness) {
        setAddRandomness(shouldAddRandomness);
    }

    async function testRange(config, key, start, end, startCounter) {

        console.log("testRange", start, end, startCounter);
        let counter = 0;
        for (let j = start; j <= end; isInt(start) ? j++ : j = j + .1) {
            let tempConfig = JSON.parse(JSON.stringify(config));
            tempConfig[key] = j;
            let finalCounter = startCounter + counter;

            setTimeout(async (c) => {

                console.log("calling evaluate config", c);
                evaluateConfig(tempConfig, Math.round(c));

            }, 100 * counter, finalCounter);

            ++counter;
        }

        return counter;
    }

    async function handleEvaluateOtherSymbol() {
        let startToUse = startDate;
        let endToUse = endDate;
        let strategyId = data.strategyId;
        let url = "/api/strategySandboxEvaluator?strategyId=" + strategyId + "&symbol=" + showSymbol + "&timeframe=" + data.timeframe
        if (startDate) url += "&startDate=" + startToUse.getFullYear().toString() + "-" + (startToUse.getMonth() + 1).toString() + "-" + (startToUse.getDate()).toString();
        if (endDate) url += "&endDate=" + endToUse.getFullYear().toString() + "-" + (endToUse.getMonth() + 1).toString() + "-" + (endToUse.getDate()).toString();
        url += "&addRandomness=" + (addRandomness ? 'true' : 'false');
        const configToUse = JSON.stringify(config)
        console.log("handleEvaluate", configToUse);
        console.log("handleEvaluate", url);

        const r = await (await fetch(url, {
            method: 'POST',
            body: configToUse
        })).json();
        console.log(r);
        setLastRunPerformance(r);
    }

    async function handleEvaluateRange() {
        console.log("handleEvaluateRange");
        console.log("config", config);
        console.log("maxConfig", maxConfig);
        setPerformanceArray([]);
        setShouldScrollToHistory(true);
        setHistoryAccordionExpanded(true);

        let keys = Object.keys(maxConfig);

        let counter = 0;

        if (keys.length === 1) {
            let key = keys[0];
            setRangeParameter(key);

            let start = Number(config[key]);
            let end = Number(maxConfig[key]);

            await testRange(config, key, start, end, counter);
        } else {
            let primaryKey = keys[0];
            let secondaryKey = keys[1];
            setRangeParameter(secondaryKey);

            let start = Number(config[primaryKey]);
            let end = Number(maxConfig[primaryKey]);

            let secondaryStart = Number(config[secondaryKey]);
            let secondaryEnd = Number(maxConfig[secondaryKey]);

            for (let i = start; i < end; isInt(start) ? i++ : i = i + .1) {
                let tempConfig = JSON.parse(JSON.stringify(config));
                tempConfig[primaryKey] = i;

                await testRange(tempConfig, secondaryKey, secondaryStart, secondaryEnd, counter);
                counter += isInt(secondaryStart) ? (secondaryEnd - secondaryStart) : (secondaryEnd - secondaryStart) / .1;
            }
        }
    }

    function handleConfigUpdate(c) {
        console.log(c);
        setConfig(c);
        handleEvaluate(c);
    }

    function handleMaxConfigUpdated(c) {
        console.log(c);
        setMaxConfig(c);
    }

    function displayAlgoLinks() {
        let links = algos.filter(a => a.name === data.algo_name && a.symbol === data.symbol);
        if (links.length) {
            return links.map(a => {
                return <><Link to={"/algo/" + a.idalgos}>{a.display_name} - {a.trade_symbol}</Link><br></br></>
            })
        }
    }

    function getTrades() {
        if (lastRunPerformance && lastRunPerformance.trades && lastRunPerformance.trades.length) {
            return lastRunPerformance.trades.map(t => {
                return {
                    purchase_date: t.purchaseDate,
                    purchase_price: t.purchasePrice,
                    sell_date: t.sellDate,
                    sell_price: t.sellPrice,
                    profitPercentage: t.profitPercentage,
                    purchase_data: t.purchaseData,
                    sell_data: t.sellData
                }
            })
        } else {
            return [];
        }
    }

    function handleCreateAlgoClosed(result) {
        console.log("handleCreateAlgoClosed")
        setModalOpen(false);
        setUpdates(updates + 1);
        if (result)
            setResult(result);
    }

    function onPerformanceResultsSelected(perf) {
        console.log("Update the charts to these results", perf)
    }

    const pendingConfigMenuOpen = Boolean(anchorEl);
    const handleOpenConfigMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseConfigMenu = () => {
        setAnchorEl(null);
    };

    function updateTimePeriodChartData(performanceData) {
        console.log("updateTimePeriodChartData", performanceData);
        if (!performanceData || !performanceData.timePeriodStats) {
            setTimePeriodChartData(null);
            return;
        }

        let array = [["Year", "Profit", { role: "style" }, "Avgerage"]];
        let sum = 0;
        let count = 0;
        Object.keys(performanceData.timePeriodStats).forEach(key => {
            let profit = performanceData.timePeriodStats[key];
            sum += profit;
            ++count;
            let color = profit >= 0 ? '#B2D8B2' : '#B85D5D';
            array.push([key, profit, color, sum / count]);
        });
        setTimePeriodChartData(array);
    }

    return (
        <div>
            {!shouldAllowView() ?
                <>Not allowed</>
                :
                <>
                    <Accordion>
                        <AccordionSummary
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <h4>Id: {data.idtrading_strategy_alerts} ({data.symbol} / {data.algo_name})</h4>
                        </AccordionSummary>
                        <AccordionDetails>
                            <table width="100%" border="2">
                                <tr>
                                    <td>Algo Name: {data.idtrading_strategy_alerts} - {data.algo_name}</td>
                                    <td>Symbol: {data.symbol}</td>
                                    <td>Strategy: {data.name}</td>
                                    <td>Timeframe: {data.timeframe === 0 ? "Daily" : "Weekly"}</td>
                                    <td>Start Date: <DatePicker showMonthYearPicker className="bg-transparent" selected={alertStartDate} onChange={(date) => setAlertStartDate(date)} /></td>

                                    <td>Last Triggered<br></br>{data.last_triggered}
                                        {shouldAllowEdits() ? <><br></br><button onClick={handlePauseClicked}>{data.paused ? "Unpause" : "Pause"}</button></> : null}
                                    </td>
                                    <td>
                                        <>
                                            {displayAlgoLinks()}
                                        </>
                                    </td>
                                </tr>
                            </table>
                        </AccordionDetails>
                    </Accordion>

                    <table ref={configSectionRef} width="100%" cellPadding={10}>
                        <tr valign='bottom'>
                            <td align='left' >
                                <AlertConfiguration config={config} maxConfig={maxConfig} defaultConfig={defaultConfig} onConfigUpdated={handleConfigUpdate} onMaxConfigUpdated={handleMaxConfigUpdated} onEvaluateRange={handleEvaluateRange} showMaxConfig={!props.mobileView} />
                            </td>
                            <td align='left' width="250px">
                                <AlertEvaluationResults mobileView={props.mobileView} performance={lastRunPerformance} performanceArray={performanceArray} shouldShowTrades={!props.mobileView && Object.keys(maxConfig).length === 0} />
                            </td>
                            <td align='left' >

                                <StockChart symbol={showSymbol ? showSymbol : data.symbol} trades={getTrades()} />
                                <AlertProfitChart symbol={data.symbol} isShort={data.short === 1 || data.short === true} showDrawdown={showDrawdown} performance={lastRunPerformance} startDate={new Date(startDate)} endDate={new Date(endDate)} />
                                <center><Link onClick={() => setShowDrawdown(!showDrawdown)}>{showDrawdown ? "Show Profit" : "Show Drawdown"}</Link></center>
                                <br></br>
                                <center>
                                    <QuoteDateAnalysis symbol={data.symbol} trades={getTrades()} />
                                </center>
                            </td>
                        </tr>
                    </table>

                    <ActionResult result={result} />

                    <AlertDataSample onDataSampleUpdated={onDataSampleUpdated} onAddRandomnessUpdated={onAddRandomnessUpdated} />

                    <br></br>

                    <div className='sameline'>
                        < Dropdown width="150" onSelect={(e) => setShowSymbol(e)}>
                            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                {showSymbol}
                            </Dropdown.Toggle>

                            <Dropdown.Menu  >
                                {symbols.map(sym => {
                                    return (<Dropdown.Item as='showSymbol' eventKey={sym} value={sym}>{sym}</Dropdown.Item>)
                                })}
                            </Dropdown.Menu>
                        </Dropdown >
                        <button onClick={() => handleEvaluateOtherSymbol()}>Show Symbol</button>
                    </div>

                    <>
                        <br></br>
                        <button onClick={() => handleReset()}>Reset</button>
                        &nbsp;&nbsp;&nbsp;<button onClick={() => handleEvaluate(config)}>Evaluate</button>
                        &nbsp;&nbsp;&nbsp;<button onClick={handleEvaluateRange}>Evaluate Range</button>
                        &nbsp;&nbsp;&nbsp;<button onClick={() => handleMonteCarlo(config)}>Monte Carlo</button>
                        &nbsp;&nbsp;x&nbsp;<input type="text" size="4" defaultValue={10} onChange={(e) => setMonteCarloCount(e.target.value)} />
                        &nbsp;&nbsp;&nbsp;<button onClick={() => handleStrip(config)}>Strip</button>
                        &nbsp;&nbsp;&nbsp;<button onClick={handleClearResults}>Clear Results</button>
                        <br></br>
                        <br></br>
                        <div hidden={!shouldAllowEdits()} style={{ borderStyle: 'solid', padding: '5px' }}>
                            {shouldAllowEdits() ? <Link onClick={() => setModalOpen(true)}>Create Algo</Link> : null}
                            {shouldAllowEdits() ? <>&nbsp;&nbsp;&nbsp;&nbsp;<button onClick={handleSubmit}>Save</button></> : null}
                            {shouldAllowEdits() && algoId ? <>&nbsp;&nbsp;&nbsp;&nbsp;<button onClick={handleSyncBacktestTrades}>Sync Backtests</button></> : null}

                            <Button
                                id="basic-button"
                                aria-controls={pendingConfigMenuOpen ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={pendingConfigMenuOpen ? 'true' : undefined}
                                onClick={handleOpenConfigMenu}
                            >
                                Pending Config Changes
                            </Button>

                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={pendingConfigMenuOpen}
                                onClose={handleCloseConfigMenu}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={loadRememberedConfig}>Load Remembered Config</MenuItem>
                                <MenuItem onClick={handleRememberConfig}>Remember Config</MenuItem>
                                <MenuItem onClick={handleForgetConfig}>Forget Config</MenuItem>
                            </Menu>
                        </div>

                    </>

                    <AlertTradeResultsChart showDrawdown={showDrawdown} trades={getTrades()} />

                    {timePeriodChartData && timePeriodChartData.length ?
                        <>
                            <br></br>
                            <h4>Yearly Results</h4>
                            <Chart
                                chartType="ComboChart"
                                width={"100%"}
                                data={timePeriodChartData}
                                chartPackages={["corechart", "controls"]}
                                options={{
                                    legend: 'none',
                                    seriesType: "bars",
                                    series: {
                                        1: { type: "line" },
                                    }
                                }}
                            />

                        </>
                        : null}

                    <br />
                    <h4>Parameter Sensitivity Tests</h4>
                    {sensitivityTests && sensitivityTests.length ?
                        <RichTable data={sensitivityTests} mappers={[
                            { title: 'Parameter', field: 'parameter_name' },
                            { title: 'Start', field: 'start_value' },
                            { title: 'End', field: 'end_value' },
                            { title: 'Increment', field: 'increment' },
                            { title: 'Run', formatter: runTestFormatter },
                            { title: 'Delete', formatter: deleteTestFormatter }
                        ]} />
                        : <p>No sensitivity tests created.</p>
                    }

                    <br></br>
                    <Accordion
                        ref={historyAccordionRef}
                        expanded={historyAccordionExpanded}
                        onChange={(e, isExpanded) => setHistoryAccordionExpanded(isExpanded)}
                    >
                        <AccordionSummary
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <h4>History</h4>
                        </AccordionSummary>
                        <AccordionDetails>
                            <input type="checkbox" value={shouldSaveHistory} onChange={() => setShouldSaveHistory(!shouldSaveHistory)} />Save History
                            <ParameterSensitivityChart parameter={rangeParameter} showDrawdown={showDrawdown} performance={performance} performanceArray={performanceArray} />
                            {shouldAllowEdits() && rangeParameter ? <center><br /><button onClick={() => setCreateParamTestModalOpen(true)}>Create Parameter Test</button></center> : null}

                            <AlertPerformanceHistory mobileView={props.mobileView} performanceArray={performanceArray} onResultsSelected={onPerformanceResultsSelected} />
                        </AccordionDetails>
                    </Accordion>

                    <br></br>
                    <Accordion>
                        <AccordionSummary
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <h4>Data Analysis</h4>
                        </AccordionSummary>
                        <AccordionDetails>
                            <AlertTradeAnalysis trades={getTrades()} />
                        </AccordionDetails>
                    </Accordion>



                    <br></br>
                    <Accordion>
                        <AccordionSummary
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <h4>Trades</h4>
                        </AccordionSummary>
                        <AccordionDetails>
                            <AlertTrades mobileView={props.mobileView} trades={getTrades()} />
                        </AccordionDetails>
                    </Accordion>

                    <br></br>
                    <Accordion>
                        <AccordionSummary
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <h4>Updates</h4>
                        </AccordionSummary>
                        <AccordionDetails>
                            <AlertConfigChanges alertId={alertId} />
                        </AccordionDetails>
                    </Accordion>


                    <CreateAlgoModal isOpen={modalOpen} name={data.algo_name} symbol={data.symbol} onClose={handleCreateAlgoClosed} mobileView={props.mobileView} />

                    <CreateParameterTestModal
                        isOpen={createParamTestModalOpen}
                        onClose={handleCreateParamTestModalClose}
                        alertId={alertId}
                        parameterName={rangeParameter}
                        startValue={config[rangeParameter]}
                        endValue={maxConfig[rangeParameter]}
                        increment={isInt(config[rangeParameter]) ? 1 : 0.1}
                    />
                </>
            }

        </div >);
}

export default ConfigureAlert;